var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ElementRef, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environmentOm } from 'src/environment-om';
import { ReportsApi } from '../../../api/reports-api';
import { ReportHelper } from '../../report-helper';
export class LegislativeAssetTipReportComponent {
    constructor(reportHelper, reportsApi, route, titleService) {
        this.reportHelper = reportHelper;
        this.reportsApi = reportsApi;
        this.route = route;
        this.isGenerating = false;
        this.error = false;
        this.searchLocation = {};
        this.searchLocationType = '';
        this.defaultBasemap = {
            tileUrl: environmentOm.basemapURL + '/rest/services/basemaps/penndotbasemap/MapServer/tile',
            thumbnailTile: '/7/48/36',
            tileTemplate: '/{level}/{row}/{col}',
            title: 'PennDOT'
        };
        titleService.setTitle(titleService.getTitle() + ' : Legislative Asset TIP Report');
    }
    ngOnInit() {
        this.isGenerating = true;
        this.route.paramMap.subscribe((x) => __awaiter(this, void 0, void 0, function* () {
            const reportParams = JSON.parse(window.localStorage.getItem(x.get('id')));
            this.houseDistrictNumber = reportParams.houseDistrictNumber ? reportParams.houseDistrictNumber : null;
            this.senateDistrictNumber = reportParams.senateDistrictNumber ? reportParams.senateDistrictNumber : null;
            this.congressDistrictNumber = reportParams.congressDistrictNumber ? reportParams.congressDistrictNumber : null;
            this.reportParams = this.getReportParams();
            yield this.loadReport();
            this.loadMap();
            this.getSearchLocation();
            this.isGenerating = false;
        }));
    }
    getReportParams() {
        if (this.congressDistrictNumber) {
            return {
                legisNum: this.congressDistrictNumber.toString(),
                legisType: 'C',
                regionType: 'congress',
                tipType: 'A'
            };
        }
        else if (this.houseDistrictNumber) {
            return {
                legisNum: this.houseDistrictNumber.toString(),
                legisType: 'H',
                regionType: 'house',
                tipType: 'A'
            };
        }
        else if (this.senateDistrictNumber) {
            return {
                legisNum: this.senateDistrictNumber.toString(),
                legisType: 'S',
                regionType: 'senate',
                tipType: 'A'
            };
        }
        else {
            return null;
        }
    }
    loadReport() {
        return __awaiter(this, void 0, void 0, function* () {
            this.reportData = yield this.reportsApi.getLegislativeAssetTipReportData(this.reportParams);
        });
    }
    loadMap() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = this.reportParams;
            const projectIds = this.getProjectIds();
            // create search criteria object for applySearchCriteriaToLayer function
            const searchCriteria = {
                region: {}
            };
            switch (params.regionType) {
                case 'congress':
                    params.regionType = 'congress_districts';
                    searchCriteria.region.congressDistrictNumber = params.legisNum;
                    break;
                case 'house':
                    params.regionType = 'house_districts';
                    searchCriteria.region.houseDistrictNumber = params.legisNum;
                    break;
                case 'senate':
                    params.regionType = 'senate_districts';
                    searchCriteria.region.senateDistrictNumber = params.legisNum;
                    break;
                default:
                    break;
            }
            const layerId = environmentOm.layers.filter(x => x.name === 'mpmsProjectsAll')[0].id;
            const legislativeLayerId = environmentOm.layers.filter(x => x.name === String(this.reportParams.regionType.split('_')[0]) + 'District')[0].id;
            const symbols = this.reportHelper.getBoundaryLayerProperties(this.mapRef.nativeElement.LayerService.legendService);
            try {
                yield this.mapRef.nativeElement.ready;
                yield this.mapRef.nativeElement.setBasemapsFromConfig(this.defaultBasemap);
                const layerSettings = [{
                        id: layerId,
                        query: {
                            operator: 'AND', subqueries: [
                                { field: params.regionType, operator: '=', value: params.legisNum },
                                { field: 'project_id', operator: 'INCLUDES', value: projectIds.toString() },
                                { field: 'tip_flag', operator: '=', value: 'Y' }
                            ]
                        }
                    },
                    {
                        id: legislativeLayerId,
                        query: { field: 'leg_district_no', operator: '=', value: parseInt(params.legisNum, 10) },
                        opacity: 0.5,
                        symbols,
                        zoomToLayer: true,
                        generateNewLayer: true
                    }];
                this.mapRef.nativeElement.LayerService.addMapcoreLayersToMap([...layerSettings].reverse());
            }
            catch (error) {
            }
        });
    }
    getProjectIds() {
        const projectIds = [];
        for (const project of this.reportData.projects) {
            projectIds.push(project.projectId);
        }
        return projectIds;
    }
    /**
     * Search location object for top of report
     */
    getSearchLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.congressDistrictNumber) {
                this.searchLocation = yield this.reportHelper.getCongressionalDistrictByName(this.congressDistrictNumber);
                this.searchLocationType = this.reportParams.legisType;
            }
            if (this.senateDistrictNumber) {
                this.searchLocation = yield this.reportHelper.getSenateDistrictByName(this.senateDistrictNumber);
                this.searchLocationType = this.reportParams.legisType;
            }
            if (this.houseDistrictNumber) {
                this.searchLocation = yield this.reportHelper.getHouseDistrictByName(this.houseDistrictNumber);
                this.searchLocationType = this.reportParams.legisType;
            }
        });
    }
}
